import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { IUser } from '../../../../../chatperk-core/interfaces/user.interface';
import { AuthService } from "../../../../../chatperk-core/services/auth.service";

export const fetchMyProfileResolver: ResolveFn<IUser> = () => {
  const myProfileService = inject(AuthService);
  return myProfileService.getMyProfile();
}